import * as React from 'react';
/**
 *
 * Original name: search
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=1%3A81
 *
 */
export const SearchLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m19.03 17.97-4.009-4.01A5.89 5.89 0 0 0 16 10.5C16 7.056 13.944 5 10.5 5S5 7.056 5 10.5 7.056 16 10.5 16a5.89 5.89 0 0 0 3.461-.979l4.009 4.01 1.06-1.061ZM6.5 10.5c0-2.617 1.383-4 4-4s4 1.383 4 4-1.383 4-4 4-4-1.383-4-4Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
